import Vue from 'vue';
import HintCard from '@/components/pages/mainPage/tables/hints/hintCard.vue';
import SwiperSlide from '@/components/global/Swiper/SwiperSlide';
import Swiper from '@/components/global/Swiper/Swiper.vue';
export default Vue.extend({
    props: {
        collapse: {
            required: true
        },
        hintsData: {
            type: Array,
            required: true
        }
    },
    components: { Swiper, SwiperSlide, HintCard },
    data: () => ({
        hintsSliderHasInited: false
    }),
    computed: {
        slidesPerView() {
            if (this.maw(670))
                return 1;
            if (this.maw(990))
                return 2;
            if (this.maw(1090))
                return 3;
            return 4;
        }
    },
    methods: {
        onCollapseChange() {
            this.$emit('on-collapse-change');
        },
        onVisibilityChange() {
            this.$emit('on-visibility-change');
        }
    },
    watch: {
        collapse() {
            if (this.collapse === 0) {
                this.$refs.swiperComponent.updateSwiperSlides();
            }
        }
    }
});
